export async function loadPaymentsGuidesUseCase(data, guideRepostitory) {
    const result = await guideRepostitory.load_payments(data);

    return result;
}